const Aguascalientes = {
  parties: [
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'Va por Aguascalientes',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'María Teresa Jiménez Esquivel',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PAN, PRD y PRI',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/maria-teresa-jimenez-esquivel.png',
        },
      ],
      block: 'PAN, PRD y PRI',
      settings: {
        color: '#1400A9',
      },
      election_key: 'infobae.com:mexico:aguascalientes:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Hacemos Historia por Aguascalientes',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Martha Cecilia Márquez Alvarado',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PVEM y PT',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/martha-cecilia-marquez-alvarado.png',
        },
      ],
      block: 'PVEM y PT',
      settings: {
        color: '#CC850D',
      },
      election_key: 'infobae.com:mexico:aguascalientes:locales:governors:2022',
    },
    {
      party_id: '5',
      votes: 0,
      votes_percent: 0.0,
      name: 'Fuerza por México',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Natzielly Teresita Rodríguez Calzada',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Fuerza por México',
          avatar:
            'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/natzielly-teresita-rodriguez-calzada.png',
        },
      ],
      block: 'Fuerza por México',
      settings: {
        color: '#F51F8C',
      },
      election_key: 'infobae.com:mexico:aguascalientes:locales:governors:2022',
    },
    {
      party_id: '4',
      votes: 0,
      votes_percent: 0.0,
      name: 'Morena',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Nora Ruvalcaba Gámez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Morena',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/nora-ruvalcaba-gamez.png',
        },
      ],
      block: 'Morena',
      settings: {
        color: '#7B0000',
      },
      election_key: 'infobae.com:mexico:aguascalientes:locales:governors:2022',
    },
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Anayeli Muñoz Moreno',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/anayeli-munoz-moreno.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#ED6D12',
      },
      election_key: 'infobae.com:mexico:aguascalientes:locales:governors:2022',
    },
  ],
};

const Durango = {
  parties: [
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Hacemos Historia',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Alma Marina Vitela Rodríguez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Morena, PT, PVEM y RSP',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/alma-marina-vitela-rodriguez.png',
        },
      ],
      block: 'Morena, PT, PVEM y RSP',
      settings: {
        color: '#B41F15',
      },
      election_key: 'infobae.com:mexico:durango:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Va por Durango',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Esteban Alejandro Villegas Villarreal',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PRI, PAN y PRD',
          avatar:
            'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/esteban-alejandro-villegas-villarreal.png',
        },
      ],
      block: 'PRI, PAN y PRD',
      settings: {
        color: '#3b83bd',
      },
      election_key: 'infobae.com:mexico:durango:locales:governors:2022',
    },
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Patricia Flores Elizondo',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/patricia-flores-elizondo.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#FF8300',
      },
      election_key: 'infobae.com:mexico:durango:locales:governors:2022',
    },
  ],
};

const Hidalgo = {
  parties: [
    {
      party_id: '4',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Hacemos Historia en Hidalgo',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Julio Ramón Menchaca Salazar',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Juntos Hacemos Historia en Hidalgo',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/julio-ramon-menchaca-salazar.png',
        },
      ],
      block: 'Juntos Hacemos Historia en Hidalgo',
      settings: {
        color: '#B41F15',
      },
      election_key: 'infobae.com:mexico:hidalgo:locales:governors:2022',
    },
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Va por Hidalgo',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Alma Carolina Viggiano Austria',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Va por Hidalgo',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/alma-carolina-viggiano-austria.png',
        },
      ],
      block: 'Va por Hidalgo',
      settings: {
        color: '#3b83bd',
      },
      election_key: 'infobae.com:mexico:hidalgo:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Francisco Xavier Berganza Escorza',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar:
            'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/francisco-xavier-berganza-escorza.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#ED6D12',
      },
      election_key: 'infobae.com:mexico:hidalgo:locales:governors:2022',
    },
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'Partido Verde',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'José Luis Lima Morales',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Partido Verde',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/jose-luis-lima-morales.png',
        },
      ],
      block: 'Partido Verde',
      settings: {
        color: '#00A929',
      },
      election_key: 'infobae.com:mexico:hidalgo:locales:governors:2022',
    },
  ],
};

const Oaxaca = {
  parties: [
    {
      party_id: '7',
      votes: 0,
      votes_percent: 0.0,
      name: 'PRI y PRD',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Alejandro Áviles Álvarez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PRI y PRD',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/alejandro-aviles-alvarez.png',
        },
      ],
      block: 'PRI y PRD',
      settings: {
        color: '#E40000',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '6',
      votes: 0,
      votes_percent: 0.0,
      name: 'Candidato Independiente',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Jesús López Rodríguez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Candidato Independiente',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/jesus-lopez-rodriguez.png',
        },
      ],
      block: 'Candidato Independiente',
      settings: {
        color: '#004E1D',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '5',
      votes: 0,
      votes_percent: 0.0,
      name: 'Candidato Independiente',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Mauricio Cruz Vargas',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Candidato Independiente',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/mauricio-cruz-vargas.png',
        },
      ],
      block: 'Candidato Independiente',
      settings: {
        color: '#004E1D',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '4',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Hacemos Historia en Oaxca',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Salomón Jara Cruz',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Morena, PT, PVEM y Partido Unidad Popular',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/salomon-jara-cruz.png',
        },
      ],
      block: 'Morena, PT, PVEM y Partido Unidad Popular',
      settings: {
        color: '#B41F15',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Partido Nueva Alianza',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Bersahín Asael López López',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Partido Nueva Alianza',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/bersahin-asael-lopez-lopez.png',
        },
      ],
      block: 'Partido Nueva Alianza',
      settings: {
        color: '#00A6AD',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Dulce Alejandra García Morlan',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/dulce-alejandra-garcia-morlan.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#ED6D12',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'Partido Acción Nacional',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Antonia Natividad Díaz Jiménez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Partido Acción Nacional',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/antonia-natividad-diaz-jimenez.png',
        },
      ],
      block: 'Partido Acción Nacional',
      settings: {
        color: '#1400A9',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
  ],
};

const Quintana = {
  parties: [
    {
      party_id: '5',
      votes: 0,
      votes_percent: 0.0,
      name: 'Va por Quintana Roo',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Laura Lynn Fernández Piña',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PAN y PRD',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/laura-lynn-fernandez-pina.png',
        },
      ],
      block: 'PAN y PRD',
      settings: {
        color: '#06318A',
      },
      election_key: 'infobae.com:mexico:quintana-roo:locales:governors:2022',
    },
    {
      party_id: '4',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Haremos Historia en Quintana Roo',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'María Elena Hermelinda Lezama Espinosa',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Morena, PT, PVEM, Fuerza por México',
          avatar:
            'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/maria-elena-hermelinda-lezama-espinosa.png',
        },
      ],
      block: 'Morena, PT, PVEM, Fuerza por México',
      settings: {
        color: '#B41F15',
      },
      election_key: 'infobae.com:mexico:quintana-roo:locales:governors:2022',
    },
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Auténtico Social',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Josúe Nivardo Mena Villanueva',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Auténtico Social',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/josue-nivardo-mena-villanueva.png',
        },
      ],
      block: 'Movimiento Auténtico Social',
      settings: {
        color: '#682676',
      },
      election_key: 'infobae.com:mexico:quintana-roo:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'José Luis Pech Várguez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/jose-luis-pech-varguez.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#ED6D12',
      },
      election_key: 'infobae.com:mexico:quintana-roo:locales:governors:2022',
    },
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'PRI',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Leslie Angelina Hendricks Rubio',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PRI',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/leslie-angelina-hendricks-rubio.png',
        },
      ],
      block: 'PRI',
      settings: {
        color: '#E40000',
      },
      election_key: 'infobae.com:mexico:quintana-roo:locales:governors:2022',
    },
  ],
};

const Tamaulipas = {
  parties: [
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Hacemos Historia en Tamaulipas',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Américo Villarreal Anaya',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Morena, PT, PVEM',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/americo-villarreal-anaya.png',
        },
      ],
      block: 'Morena, PT, PVEM',
      settings: {
        color: '#B41F15',
      },
      election_key: 'infobae.com:mexico:tamaulipas:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Va por Tamaulipas',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'César Augusto Verástegui Ostos',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PRI, PAN y PRD',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/cesar-augusto-verastegui-ostos.png',
        },
      ],
      block: 'PRI, PAN y PRD',
      settings: {
        color: '#D23026',
      },
      election_key: 'infobae.com:mexico:tamaulipas:locales:governors:2022',
    },
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Arturo Díez Gutiérrez Navarro',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/arturo-diez-gutierrez-navarro.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#ED6D12',
      },
      election_key: 'infobae.com:mexico:tamaulipas:locales:governors:2022',
    },
  ],
};

const Brasil = {
   "parties":[
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Democrático Laborista",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Ciro Gomes",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/ciro-gomes.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#F70000"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Nuevo",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Felipe D’Avila",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/felipe-d’avila.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#ff8000"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Liberal",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Jair Bolsonaro",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/jair-bolsonaro.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#3C3E90"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      },
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Democracia Cristiana",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"José Maria Eymael",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/jose-maria-eymael.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#E1DA01"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      },
      {
         "party_id":"11",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Laborista Brasileño",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Kelmon Souza",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/kelmon-souza.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#2DA7AC"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      },
      {
         "party_id":"9",
         "votes":0,
         "votes_percent":0,
         "name":"Unidad Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Léo Péricles",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/leo-pericles.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#3e4144"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"PT",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Luiz Inácio Lula da Silva",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/luiz-inacio-lula-da-silva.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#C60000"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Democrático Brasileño",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Simone Tebet",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/simone-tebet.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#808080"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      },
      {
         "party_id":"10",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Comunista Brasileño",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Sofia Manzano",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/sofia-manzano.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#F70000"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      },
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Unión Brasil",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Soraya Thronicke",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/soraya-thronicke.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#2448A0"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Socialista de los Trabajadores",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Vera Lúcia Salgado",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/vera-lucia-salgado.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#F7F700"
         },
         "election_key":"infobae.com:brasil:all:general:president:2022"
      }
   ],
}

const BrasilVuelta = {
   "parties":[
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"PT",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Luiz Inácio Lula da Silva",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general_vuelta/img/avatars/luiz-inacio-lula-da-silva.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#C60000"
         },
         "election_key":"infobae.com:brasil:all:general_vuelta:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Liberal",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Jair Bolsonaro",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/brasil/general_vuelta/img/avatars/jair-bolsonaro.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#3C3E90"
         },
         "election_key":"infobae.com:brasil:all:general_vuelta:president:2022"
      }
   ],
}

const Default = {
  "parties":[
     {
        "party_id":"1",
        "votes":0,
        "votes_percent":0,
        "name":"Por Definir",
        "candidates":[
           {
              "candidate_id":"1",
              "fullname":"Por Definir",
              "votes":0,
              "votes_percent":0,
              "block_name":"Por Definir",
              "avatar":"https://statics-ecp.infobae.com/2022/brasil/general/img/avatars/avatar.png"
           }
        ],
        "block":"Por Definir",
        "settings":{
           "color":"#000000"
        },
        "election_key":"Por Definir"
     },
  ],
}

const Lima = {
   "parties":[
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Podemos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Daniel Urresti",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/daniel-urresti.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#0C4C9B"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Frente de la Esperanza",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Elizabeth León",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/elizabeth-leon.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#64BB53"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Somos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"George Forsyth",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/george-forsyth.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#234B8B"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Juntos por el Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Gonzalo Alegría",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/gonzalo-alegria.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#5CBC14"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Avanza País",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"María Soto Velásquez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/maria-soto-velasquez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#153f93"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Alianza para el Progreso",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Omar Chehade",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/omar-chehade.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1C62AB"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Renovación Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Rafael López Aliaga",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/rafael-lopez-aliaga.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#049BD4"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"Perú Libre",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Yuri Castro",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/yuri-castro.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#e90000"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      }
   ],
}

const Arequipa = {
   "parties":[
      {
         "party_id":"14",
         "votes":0,
         "votes_percent":0,
         "name":"Arequipa Unidos por el Gran Cambio",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Jorge Luis Suclla Medina",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/jorge-luis-suclla-medina.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#0089cf"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"13",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Morado",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"José Fabrizzio Díaz Contreras",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/jose-fabrizzio-diaz-contreras.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#5b108b"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"12",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Regional Revalora",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Miluska Olivera Mogrovejo",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/miluska-olivera-mogrovejo.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#cd0079"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"11",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Regional Arequipa Avancemos",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Héctor Hugo Herrera Herrera",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/hector-hugo-herrera-herrera.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#ffca00"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"10",
         "votes":0,
         "votes_percent":0,
         "name":"Avanza País",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Dolores Marlene Corimanya Sicha",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/dolores-marlene-corimanya-sicha.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#153f93"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"9",
         "votes":0,
         "votes_percent":0,
         "name":"Perú Libre",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Vladimir Justo Huaranca Tejada",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/vladimir-justo-huaranca-tejada.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#e90000"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Juntos por el Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Fernando Zeballos Patrón",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/fernando-zeballos-patron.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#5cbe12"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Fuerza Arequipeña",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Marco Tulio Falconi Picardo",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/marco-tulio-falconi-picardo.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#ec2d25"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Frente de la Esperanza 2021",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"María Alejandra Vásquez Sánchez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/maria-alejandra-vasquez-sanchez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#67bd50"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Somos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Rosario Paredes Eyzaguirre",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/rosario-paredes-eyzaguirre.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1a468f"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Arequipa Tradición y futuro",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Javier Enrique Ismodes Talavera",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/javier-enrique-ismodes-talavera.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#bc2024"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Yo Arequipa",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Rohel Sánchez Sánchez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/rohel-sanchez-sanchez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#841217"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"Renovación Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Mildred Shirley Follana Álvarez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/mildred-shirley-follana-alvarez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#049ad7"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Alianza para el Progreso",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Lili Margoth Juárez Salazar",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/lili-margoth-juarez-salazar.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1c5cab"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      }
   ],
}

const LaLibertad = {
   "parties":[
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Trabajo más trabajo",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Elías Nicolás Rodríguez Zavaleta",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/elias-nicolas-rodriguez-zavaleta.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#fe0000"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Alianza Para el Progreso",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"César Acuña Peralta",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/cesar-acuna-peralta.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1c5cab"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Súmate",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Marino Teófilo Lavado Valdivia",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/marino-teofilo-lavado-valdivia.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#fecb02"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Acción Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Alfonso Paúl Ibáñez Carranza",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/alfonso-paul-ibanez-carranza.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#e51a22"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Regional Fortaleza Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Mónica Paola Sánchez Minchola",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/monica-paola-sanchez-minchola.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#fef708"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Nueva Libertad",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Mariano Andrés Yupanqui Miñano",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/mariano-andres-yupanqui-minano.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#fffa25"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"Somos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Johanna Gabriela Lozada Baldwin",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/johanna-gabriela-lozada-baldwin.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1a468f"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Fuerza Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Miguel Angel Vivanco Reyes",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/miguel-angel-vivanco-reyes.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#eb6d00"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      }
   ],
}

const Cusco = {
   "parties":[
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Perú Libre",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Saúl Sánchez Santos",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/saul-sanchez-santos.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#e90000"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Alianza para el Progreso",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Boris Germain Mujica Paredes",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/boris-germain-mujica-paredes.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1c5cab"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Juntos por el Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Raúl del Castillo Alatrista",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/raul-del-castillo-alatrista.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#5cbe12"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Regional Inka Pachakuteq",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Edy Edward Cuellar Margholt",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/edy-edward-cuellar-margholt.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#91b436"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Podemos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Yulet Luna Hilares",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/yulet-luna-hilares.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#0b4e9d"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Somos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Werner Máximo Salcedo Alvarez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/werner-maximo-salcedo-alvarez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1a468f"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"Autogobierno Ayllu",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Rosmi Rivas Hurtado",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/rosmi-rivas-hurtado.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#01db03"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Frente de la Esperanza",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Carlos Ricardo Cuaresma Sánchez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/carlos-ricardo-cuaresma-sanchez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#67bd50"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      }
   ],
}

const Loreto = {
   "parties":[
      {
         "party_id":"11",
         "votes":0,
         "votes_percent":0,
         "name":"Loreto para Todos",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Tito Evil Rodríguez Pérez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/tito-evil-rodriguez-perez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#ed9527"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"10",
         "votes":0,
         "votes_percent":0,
         "name":"Perú Libre",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Yoshi Levis Lam Eléspuru",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/yoshi-levis-lam-elespuru.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#e90000"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"9",
         "votes":0,
         "votes_percent":0,
         "name":"MOVIL",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Wilfredo Moises Malpartida Gómez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/wilfredo-moises-malpartida-gomez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#0055ca"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Independiente VOGA",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Franck Gersson Marreros Pérez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/franck-gersson-marreros-perez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#ffeb00"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Juntos por Loreto",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Jorge Enrique Meléndez Celis",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/jorge-enrique-melendez-celis.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#75d3f7"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Alianza para el Progreso",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Fernando Meléndez Celis",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/fernando-melendez-celis.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1c5cab"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Fuerza Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Juan Carlos del Águila Cárdenas",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/juan-carlos-del-aguila-cardenas.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#eb6d00"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Somos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Jorge Rene Chávez Silvano",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/jorge-rene-chavez-silvano.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1a468f"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Mi Loreto",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Oscar Alexander Llapapasca Samaniego",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/oscar-alexander-llapapasca-samaniego.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#2f7a25"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Reivindiquemos Loreto",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Juan Rafael Torres Baldeon",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/juan-rafael-torres-baldeon.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#5f3209"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Esperanza Región Amazónica",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Jorge Luis Mera Ramírez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/jorge-luis-mera-ramirez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#128b5e"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      }
   ],
}

const LimaPercent = {
   "parties":[
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Podemos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Daniel Urresti",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/daniel-urresti.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#0C4C9B"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Frente de la Esperanza",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Elizabeth León",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/elizabeth-leon.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#64BB53"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Somos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"George Forsyth",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/george-forsyth.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#234B8B"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Juntos por el Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Gonzalo Alegría",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/gonzalo-alegria.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#5CBC14"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Avanza País",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"María Soto Velásquez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/maria-soto-velasquez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#153f93"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Alianza para el Progreso",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Omar Chehade",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/omar-chehade.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1C62AB"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Renovación Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Rafael López Aliaga",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/rafael-lopez-aliaga.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#049BD4"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"Perú Libre",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Yuri Castro",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/municipal/img/avatars/yuri-castro.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#e90000"
         },
         "election_key":"infobae.com:peru:lima:municipal:president:2022"
      }
   ],
}

const ArequipaPercent = {
   "parties":[
      {
         "party_id":"14",
         "votes":0,
         "votes_percent":0,
         "name":"Arequipa Unidos por el Gran Cambio",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Jorge Luis Suclla Medina",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/jorge-luis-suclla-medina.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#0089cf"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"13",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Morado",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"José Fabrizzio Díaz Contreras",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/jose-fabrizzio-diaz-contreras.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#5b108b"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"12",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Regional Revalora",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Miluska Olivera Mogrovejo",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/miluska-olivera-mogrovejo.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#cd0079"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"11",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Regional Arequipa Avancemos",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Héctor Hugo Herrera Herrera",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/hector-hugo-herrera-herrera.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#ffca00"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"10",
         "votes":0,
         "votes_percent":0,
         "name":"Avanza País",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Dolores Marlene Corimanya Sicha",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/dolores-marlene-corimanya-sicha.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#153f93"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"9",
         "votes":0,
         "votes_percent":0,
         "name":"Perú Libre",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Vladimir Justo Huaranca Tejada",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/vladimir-justo-huaranca-tejada.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#e90000"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Juntos por el Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Fernando Zeballos Patrón",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/fernando-zeballos-patron.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#5cbe12"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Fuerza Arequipeña",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Marco Tulio Falconi Picardo",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/marco-tulio-falconi-picardo.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#ec2d25"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Frente de la Esperanza 2021",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"María Alejandra Vásquez Sánchez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/maria-alejandra-vasquez-sanchez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#67bd50"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Somos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Rosario Paredes Eyzaguirre",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/rosario-paredes-eyzaguirre.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1a468f"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Arequipa Tradición y futuro",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Javier Enrique Ismodes Talavera",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/javier-enrique-ismodes-talavera.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#bc2024"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Yo Arequipa",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Rohel Sánchez Sánchez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/rohel-sanchez-sanchez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#841217"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"Renovación Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Mildred Shirley Follana Álvarez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/mildred-shirley-follana-alvarez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#049ad7"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Alianza para el Progreso",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Lili Margoth Juárez Salazar",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/lili-margoth-juarez-salazar.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1c5cab"
         },
         "election_key":"infobae.com:peru:arequipa:regional:president:2022"
      }
   ],
}

const LaLibertadPercent = {
   "parties":[
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Trabajo más trabajo",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Elías Nicolás Rodríguez Zavaleta",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/elias-nicolas-rodriguez-zavaleta.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#fe0000"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Alianza Para el Progreso",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"César Acuña Peralta",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/cesar-acuna-peralta.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1c5cab"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Súmate",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Marino Teófilo Lavado Valdivia",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/marino-teofilo-lavado-valdivia.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#fecb02"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Acción Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Alfonso Paúl Ibáñez Carranza",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/alfonso-paul-ibanez-carranza.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#e51a22"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Regional Fortaleza Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Mónica Paola Sánchez Minchola",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/monica-paola-sanchez-minchola.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#fef708"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Nueva Libertad",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Mariano Andrés Yupanqui Miñano",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/mariano-andres-yupanqui-minano.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#fffa25"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"Somos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Johanna Gabriela Lozada Baldwin",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/johanna-gabriela-lozada-baldwin.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1a468f"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Fuerza Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Miguel Angel Vivanco Reyes",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/miguel-angel-vivanco-reyes.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#eb6d00"
         },
         "election_key":"infobae.com:peru:la-libertad:regional:president:2022"
      }
   ],
}

const CuscoPercent = {
   "parties":[
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Perú Libre",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Saúl Sánchez Santos",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/saul-sanchez-santos.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#e90000"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Alianza para el Progreso",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Boris Germain Mujica Paredes",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/boris-germain-mujica-paredes.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1c5cab"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Juntos por el Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Raúl del Castillo Alatrista",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/raul-del-castillo-alatrista.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#5cbe12"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Regional Inka Pachakuteq",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Edy Edward Cuellar Margholt",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/edy-edward-cuellar-margholt.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#91b436"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Podemos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Yulet Luna Hilares",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/yulet-luna-hilares.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#0b4e9d"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Somos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Werner Máximo Salcedo Alvarez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/werner-maximo-salcedo-alvarez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1a468f"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"Autogobierno Ayllu",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Rosmi Rivas Hurtado",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/rosmi-rivas-hurtado.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#01db03"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Partido Frente de la Esperanza",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Carlos Ricardo Cuaresma Sánchez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/carlos-ricardo-cuaresma-sanchez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#67bd50"
         },
         "election_key":"infobae.com:peru:cusco:regional:president:2022"
      }
   ],
}

const LoretoPercent = {
   "parties":[
      {
         "party_id":"11",
         "votes":0,
         "votes_percent":0,
         "name":"Loreto para Todos",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Tito Evil Rodríguez Pérez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/tito-evil-rodriguez-perez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#ed9527"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"10",
         "votes":0,
         "votes_percent":0,
         "name":"Perú Libre",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Yoshi Levis Lam Eléspuru",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/yoshi-levis-lam-elespuru.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#e90000"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"9",
         "votes":0,
         "votes_percent":0,
         "name":"MOVIL",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Wilfredo Moises Malpartida Gómez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/wilfredo-moises-malpartida-gomez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#0055ca"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"8",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Independiente VOGA",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Franck Gersson Marreros Pérez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/franck-gersson-marreros-perez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#ffeb00"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"7",
         "votes":0,
         "votes_percent":0,
         "name":"Juntos por Loreto",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Jorge Enrique Meléndez Celis",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/jorge-enrique-melendez-celis.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#75d3f7"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"6",
         "votes":0,
         "votes_percent":0,
         "name":"Alianza para el Progreso",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Fernando Meléndez Celis",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/fernando-melendez-celis.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1c5cab"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"5",
         "votes":0,
         "votes_percent":0,
         "name":"Fuerza Popular",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Juan Carlos del Águila Cárdenas",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/juan-carlos-del-aguila-cardenas.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#eb6d00"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"4",
         "votes":0,
         "votes_percent":0,
         "name":"Somos Perú",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Jorge Rene Chávez Silvano",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/jorge-rene-chavez-silvano.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#1a468f"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"3",
         "votes":0,
         "votes_percent":0,
         "name":"Mi Loreto",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Oscar Alexander Llapapasca Samaniego",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/oscar-alexander-llapapasca-samaniego.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#2f7a25"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"2",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Reivindiquemos Loreto",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Juan Rafael Torres Baldeon",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/juan-rafael-torres-baldeon.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#5f3209"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      },
      {
         "party_id":"1",
         "votes":0,
         "votes_percent":0,
         "name":"Movimiento Esperanza Región Amazónica",
         "candidates":[
            {
               "candidate_id":"1",
               "fullname":"Jorge Luis Mera Ramírez",
               "votes":0,
               "votes_percent":0,
               "block_name":"Otros",
               "avatar":"https://statics-ecp.infobae.com/2022/peru/regional/img/avatars/jorge-luis-mera-ramirez.png"
            }
         ],
         "block":"Otros",
         "settings":{
            "color":"#128b5e"
         },
         "election_key":"infobae.com:peru:loreto:regional:president:2022"
      }
   ],
}

export const JSONGobMex = { Aguascalientes, Durango, Hidalgo, Oaxaca, 'Quintana Roo': Quintana, Tamaulipas };
export const JSONPresBr = { Brasil };
export const JSONDefault = { Default }; 
export const JSONPresPr =  { Lima, Arequipa, 'La Libertad' : LaLibertad, Cusco, Loreto };
export const JSONPresPrPercent =  { 'Lima' : LimaPercent, 'Arequipa' : ArequipaPercent, 'La Libertad' : LaLibertadPercent, 'Cusco' : CuscoPercent, 'Loreto' : LoretoPercent };
export const JSONPresBrBack = { BrasilVuelta };
